import { useEffect } from "react";
import SideBar from "../../layouts/SideBar";

export default function Contact() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
    return (
        <div className="contact-page">
            <div className="page-main flex gap-12">
                <div className="contact-left w-4/6">
                    <div className="page-title home-title w-6/6">Liên hệ</div>
                    <div className="contact-content">
                        <div className="contact-host mt-4">
                            <div className="contact-host--title font-extrabold text-xl">Phòng Đào tạo trường Đại học Sài Gòn</div>
                            <div className="contact-host--phone mt-2">
                                <span className="font-bold">Số điện thoại: </span>
                                <span>028 38352 309</span>
                            </div>
                            <div className="contact-host--phone mt-2">
                                <span className="font-bold">Email: </span>
                                <span>p_daotao@sgu.edu.vn</span>
                            </div>
                            <div className="contact-host-address mt-2">
                                <span className="font-bold">Địa chỉ: </span>
                                <span>Phòng C.C007, C.C008 trường Đại học Sài Gòn - 273 An Dương Vương, Phường 3, Quận 5, TP. Hồ Chí Minh</span>
                            </div>
                        </div>
                        <div className="contact-map overflow-hidden h-auto w-full mt-12">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.6687454328116!2d106.67967527516794!3d10.759992589387773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f1c81c64183%3A0xd3109d7a7a8f753c!2zMjczIMSQLiBBbiBExrDGoW5nIFbGsMahbmcsIFBoxrDhu51uZyAzLCBRdeG6rW4gNSwgVGjDoG5oIHBo4buRIEjhu5MgQ2jDrSBNaW5oLCBWaeG7h3QgTmFt!5e0!3m2!1svi!2s!4v1700897604200!5m2!1svi!2s" width="1000" height="300" loading="lazy" ></iframe>
                        </div>
                    </div>
                </div>
                <SideBar />
            </div>
        </div>
    )
}